export default "__VITE_ASSET__C8Tbc7mX__"